import { render } from "./generic-error-modal.vue?vue&type=template&id=4d8774dd"
import script from "./generic-error-modal.vue?vue&type=script&lang=js"
export * from "./generic-error-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__